import { cloneDeep } from 'lodash';
import { v4 } from 'uuid';
import type { Building } from '@shared/models/design/building-design.model';
import type { Point2D } from '@shared/models/geometry.model';
import type { ProjectEventActivity } from '@shared/models/project-event.model';
import { translateBlueprintUnderlay } from '@shared/helpers/design/blueprint-underlay.helpers';
import { mutateShape } from '@shared/helpers/design/mutators/shape.mutator';

/** Create an independent building at a drag offset, with its creation history. */
export const planBuildingDuplicate = (
  source: Building,
  delta: Point2D,
): { building: Building; events: ProjectEventActivity[] } | undefined => {
  if (!delta[0] && !delta[1]) return undefined;
  const building = cloneDeep(source);
  building.id = v4();
  delete building.name;
  const shapeIds = new Map<string, string>();
  for (const storey of building.storeys) {
    storey.id = v4();
    storey.activities = storey.activities.map((ref) => ({ ...ref, id: v4() }));
    storey.shapes = storey.shapes.map((shape) => {
      const id = shapeIds.get(shape.id) ?? v4();
      shapeIds.set(shape.id, id);
      return mutateShape.point.translateMany({ ...shape, id }, delta);
    });
  }
  building.blueprintUnderlays = building.blueprintUnderlays?.map((underlay) =>
    translateBlueprintUnderlay({ ...underlay, id: v4() }, delta),
  );
  return {
    building,
    events: [{ kind: 'building-created', buildingId: building.id }],
  };
};
